import { useEffect, useState } from "react";
import { getInspectionQuote } from "@/lib/api";

export function useQuote(params) {
  const [quote, setQuote] = useState(null);
  const key = JSON.stringify(params);

  useEffect(() => {
    const p = JSON.parse(key);
    if (!p.service_id || p.sqft === "" || p.sqft == null) {
      setQuote(null);
      return;
    }
    const t = setTimeout(() => {
      getInspectionQuote({ ...p, sqft: Number(p.sqft) || 0, units: Number(p.units) || 1 })
        .then(setQuote)
        .catch(() => setQuote(null));
    }, 250);
    return () => clearTimeout(t);
  }, [key]);

  return quote;
}

export const CheckList = ({ title, items, priceKey, selected, onToggle, testid }) => {
  if (!items?.length) return null;
  return (
    <div className="sm:col-span-2">
      <p className="mb-2 text-sm font-medium text-slate-600">{title}</p>
      <div className="flex flex-wrap gap-2">
        {items.map((it) => {
          const on = selected.includes(it.name);
          return (
            <button
              type="button"
              key={it.name}
              data-testid={`${testid}-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => onToggle(it.name)}
              className={`rounded-full border px-4 py-2 text-sm transition-colors ${on ? "border-gold bg-gold/15 text-[#0B132B]" : "border-slate-300 text-slate-600 hover:border-gold"}`}
            >
              {it.name} {it[priceKey] > 0 && <span className="text-slate-400">+${it[priceKey]}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const toggleIn = (list, v) => (list.includes(v) ? list.filter((x) => x !== v) : [...list, v]);
